import React from 'react';
import cx from 'classnames';
import { useHistory } from 'react-router-dom';
import { ReactComponent as BackIcon } from 'assets/img/back.svg';

import s from './Back.module.scss';

export interface IBack {
  onClick?(): void,
}

const Back = ({ onClick }: IBack) => {
  const history = useHistory();
  const redirectToBack = () => history && history.goBack();
  return (
    <button type="button" className={cx(s.Back)}>
      <BackIcon className={cx(s.BackSvg)} onClick={onClick || redirectToBack} />
    </button>
  );
};

export default Back;
